import { useState, useEffect, useCallback } from 'react'
import { listWorkspaces } from '../api/vestige.js'

export function useWorkspaces() {
  const [workspaces, setWorkspaces] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  const fetch = useCallback(async () => {
    setLoading(true)
    setError(null)
    try {
      const data = await listWorkspaces()
      setWorkspaces(data)
    } catch (err) {
      setError(err.message)
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    fetch()
  }, [fetch])

  const refresh = useCallback(() => {
    fetch()
  }, [fetch])

  return { workspaces, loading, error, refresh }
}
